import { httpLogins, forgotPasswordHttp, resetPasswordHttp, totpLoginHttp, googleLogInHttp, redirectToRetrieveToken, newPasswordHttp, samlLogInHttp, redirectToSamlProvider, resetPasswordHashedKeyHttp, samlLogInHttpFromCustomPayloadProvider, changePasswordHttp } from '@/http/auth'
import { initUpdatePassword, updatePasswordFlow, updatePasswordHandler, usernamePasswordLogin, MfaHandler } from '@/services/loginFlow'
import { redirect } from '@/services/redirect'
import { getTotpState, initTotp, isTotpInitialized, totpLoginFlow } from '@/services/totp'
import { googleLogin } from '@/services/googleLogIn'
import { samlLogin } from '@/services/samlLogin'
import { loadGoogleClient } from '@/vendor/googleClientLoader'
import { challengeHandler } from '@/services/challengeHandler'
import { initResetPassword, resetPasswordFlow, resetPasswordHashFlow } from '@/services/resetPassword'
import { postMessageToParentWindow } from '@/services/postMessageToParentWindow'
import { getQueryParameter } from '@/services/getQueryParameter'
import { getValidSession } from './services/getValidSession'
import { Cookie } from './helpers/cookies'
import { getLoginAd } from './http/ads'
import { enrollAuthenticator, enrollEmail, enrollSMS, verifyEnrollmentAuthenticator, verifyEnrollmentEmail, verifyEnrollmentSMS } from './http/mfa'
import { initRedirectAfterMFA } from './services/mfa'
import { getOtpState, initOtp, otpLoginFlow, isOtpInitialized } from './services/otp'

export const injectDependencies = (app: any, router: any) => {
  const redirectImpl = redirect(router)
  const challengeHandlerImpl = challengeHandler(redirectImpl, initTotp, initResetPassword, initOtp)
  const updatePasswordHandlerImpl = updatePasswordHandler(redirectImpl, initUpdatePassword)
  const mfaHandlerImpl = MfaHandler(redirectImpl, initRedirectAfterMFA)

  app.provide('usernamePasswordLogin', usernamePasswordLogin(httpLogins, redirectToRetrieveToken, challengeHandlerImpl, updatePasswordHandlerImpl, mfaHandlerImpl))
  app.provide('redirectToRetrieveToken', redirectToRetrieveToken)
  app.provide('enrollAuthenticator', enrollAuthenticator)
  app.provide('verifyEnrollmentAuthenticator', verifyEnrollmentAuthenticator)
  app.provide('enrollSMS', enrollSMS)
  app.provide('verifyEnrollmentSMS', verifyEnrollmentSMS)
  app.provide('enrollEmail', enrollEmail)
  app.provide('verifyEnrollmentEmail', verifyEnrollmentEmail)
  app.provide('getValidSession', getValidSession(() => Date.now(), Cookie.get))
  app.provide('forgotPassword', forgotPasswordHttp)
  app.provide('totpLoginFlow', totpLoginFlow(totpLoginHttp, redirectToRetrieveToken, challengeHandlerImpl, updatePasswordHandlerImpl))
  app.provide('otpLoginFlow', otpLoginFlow(totpLoginHttp, redirectToRetrieveToken, challengeHandlerImpl, updatePasswordHandlerImpl))
  app.provide('resetPassword', resetPasswordHttp)
  app.provide('redirect', redirectImpl)
  app.provide('isTotpInitialized', isTotpInitialized)
  app.provide('isOtpInitialized', isOtpInitialized)
  app.provide('googleLogin', googleLogin(googleLogInHttp, redirectToRetrieveToken))
  app.provide('samlLogin', samlLogin(samlLogInHttp, redirectToSamlProvider, samlLogInHttpFromCustomPayloadProvider))
  app.provide('loadGoogleClient', loadGoogleClient)
  app.provide('resetPasswordFlow', resetPasswordFlow(newPasswordHttp, redirectToRetrieveToken))
  app.provide('updatePasswordFlow', updatePasswordFlow(changePasswordHttp))
  app.provide('postMessageToParentWindow', postMessageToParentWindow)
  app.provide('getQueryParameter', getQueryParameter)
  app.provide('resetPasswordHashFlow', resetPasswordHashFlow(resetPasswordHashedKeyHttp, redirectToRetrieveToken))
  app.provide('getLoginAd', getLoginAd)
  app.provide('getTotpState', getTotpState)
  app.provide('getOtpState', getOtpState)
}
